module.exports = __webpack_public_path__ + "static/media/fb_icon.3912e6ef.png";